import React from 'react'
import CollectionListDesktop from './desktop';
import CollectionListMobile from './mobile';

const CollectionList = (data) => {
	const { defaultSettings: { colorSettings } } = data

	return (
		<>
			<CollectionListDesktop data={data} colorSettings={colorSettings}  />
			<CollectionListMobile data={data} />
		</>
	)
}

export default CollectionList